import { render } from "@/components/pages/blank/Blank.html?vue&type=template&id=25c3069f&external"
import script from "@/components/pages/blank/Blank.js?vue&type=script&lang=js&external"
export * from "@/components/pages/blank/Blank.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__